import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessageRequest, MessageResponse } from '../models/message';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MessageService {
  private http = inject(HttpClient);
  sendMessage(messageData: MessageRequest): Observable<MessageResponse> {
    const data = {
      body: messageData.content,
      to: messageData.receiver.phoneNumber,
      sender_name: messageData.sender.name,
      media_url: messageData.media_urls,
    }
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    return this.http.post<MessageResponse>(
      `https://${environment.messagingApi}/send-sms`,
      data,
      { headers }
    );
  }
}
